import React from 'react';
import PropTypes from 'prop-types';

import { CreditCardInterestCalculator } from '@ratehub/calculators';

import PAGE_TEMPLATES from '../definitions/PageTemplates';


function CCInterestCalculator({ disclaimer, ...otherProps }) {
    return (
        <section className="rh-flex-grow-1 rh-my-0 rh-mx-auto rh-py-0_5 rh-px-0 rh-max-width-50">
            <CreditCardInterestCalculator {...otherProps} />

            <If condition={disclaimer}>
                <p className="rh-text-2xs rh-text-align-center rh-pt-0 rh-mt-1 rh-mx-0">
                    {disclaimer}
                </p>
            </If>
        </section>
    );
}

CCInterestCalculator.propTypes = {
    disclaimer: PropTypes.string,
};


CCInterestCalculator.blockKey = 'rh/cc-interest-calculator';
CCInterestCalculator.requiresLayoutRow = true;
CCInterestCalculator.supportedPageTypes = [ PAGE_TEMPLATES.calculatorsBanking ];


export default CCInterestCalculator;
